export default "__VITE_ASSET__CkBV0_37__"